import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { firestore, storage } from "../firebase";
import { doc, getDoc, setDoc, updateDoc } from "firebase/firestore";
import { ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";

function UploadPage() {
  const { studentId } = useParams(); // Öğrenci ID'si
  const [studentName, setStudentName] = useState("");
  const [electricBill, setElectricBill] = useState("");
  const [waterBill, setWaterBill] = useState("");
  const [electricBillFile, setElectricBillFile] = useState(null); // Dosya seçimi
  const [waterBillFile, setWaterBillFile] = useState(null); // Dosya seçimi
  const [decemberElectricBill, setDecemberElectricBill] = useState(""); // Aralık elektrik faturası
  const [decemberWaterBill, setDecemberWaterBill] = useState(""); // Aralık su faturası
  const [isSaving, setIsSaving] = useState(false); // Kaydetme işlemi durumu
  const navigate = useNavigate();

  useEffect(() => {
    const fetchStudentData = async () => {
      try {
        const docRef = doc(firestore, "bills", studentId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const studentData = docSnap.data();
          setStudentName(studentData.studentName);
          setDecemberElectricBill(studentData.decemberElectricBill); // Aralık faturalarını al
          setDecemberWaterBill(studentData.decemberWaterBill);
        }
      } catch (error) {
        console.error("Öğrenci verisi alınırken hata oluştu:", error);
      }
    };

    fetchStudentData();
  }, [studentId]);

  // Firebase Storage'a dosya yükleme fonksiyonu
  const uploadFile = async (file) => {
    const storageRef = ref(storage, `bills/${studentId}/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    return new Promise((resolve, reject) => {
      uploadTask.on(
        "state_changed",
        (snapshot) => {},
        (error) => reject(error),
        () => {
          getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
            resolve(downloadURL);
          });
        }
      );
    });
  };

  // Tasarruf yüzdesini hesaplama fonksiyonu
  const calculateSavingsPercentage = () => {
    const decemberElectricBillAmount = parseFloat(decemberElectricBill);
    const januaryElectricBillAmount = parseFloat(electricBill);
    
    // Elektrik tasarruf yüzdesi
    const electricSavings = ((decemberElectricBillAmount - januaryElectricBillAmount) / decemberElectricBillAmount) * 100;

    // Su tasarruf yüzdesi
    const decemberWaterBillAmount = parseFloat(decemberWaterBill);
    const januaryWaterBillAmount = parseFloat(waterBill);
    const waterSavings = ((decemberWaterBillAmount - januaryWaterBillAmount) / decemberWaterBillAmount) * 100;

    return {
      electricSavings: isNaN(electricSavings) ? 0 : electricSavings,
      waterSavings: isNaN(waterSavings) ? 0 : waterSavings,
    };
  };

  const handleSave = async () => {
    setIsSaving(true); // Kaydetme işlemi başladığında butonu devre dışı bırak
    try {
      // Dosyaları Storage'a yükle
      const electricBillUrl = electricBillFile ? await uploadFile(electricBillFile) : null;
      const waterBillUrl = waterBillFile ? await uploadFile(waterBillFile) : null;

      const { electricSavings, waterSavings } = calculateSavingsPercentage();

      const docRef = doc(firestore, "bills", studentId);
      const docSnap = await getDoc(docRef);

      if (docSnap.exists()) {
        // Belge varsa, güncelleme yap
        await updateDoc(docRef, {
          januaryElectricBill: electricBill,
          januaryWaterBill: waterBill,
          januaryElectricBillUrl: electricBillUrl,
          januaryWaterBillUrl: waterBillUrl,
          electricSavings, // Tasarruf yüzdesini ekle
          waterSavings, // Tasarruf yüzdesini ekle
        });
        console.log("Faturalar güncellendi.");
      } else {
        // Belge yoksa, yeni belge oluştur
        await setDoc(docRef, {
          studentName,
          januaryElectricBill: electricBill,
          januaryWaterBill: waterBill,
          januaryElectricBillUrl: electricBillUrl,
          januaryWaterBillUrl: waterBillUrl,
          electricSavings, // Tasarruf yüzdesini ekle
          waterSavings, // Tasarruf yüzdesini ekle
        });
        console.log("Yeni fatura kaydedildi.");
      }

      // Sonuç sayfasına yönlendir
      navigate(`/results/${studentId}`);
    } catch (error) {
      console.error("Faturalar kaydedilirken hata oluştu:", error);
    } finally {
      setIsSaving(false); // Kaydetme işlemi tamamlandığında butonu tekrar etkinleştir
    }
  };

  return (
    <div>
      <h2>Ocak Ayı Faturasını Yükle</h2>
      <form>
        <div>
          <label>Öğrenci Adı:</label>
          <input
            type="text"
            value={studentName}
            onChange={(e) => setStudentName(e.target.value)}
            disabled // Adı değiştirmeye izin vermiyoruz
          />
        </div>
        <div>
          <label>Elektrik Faturası Tüketimi(kwh):</label>
          <input
            type="number"
            value={electricBill}
            onChange={(e) => setElectricBill(e.target.value)}
          />
        </div>
        <div>
          <label>Su Faturası Tüketimi(m³):</label>
          <input
            type="number"
            value={waterBill}
            onChange={(e) => setWaterBill(e.target.value)}
          />
        </div>
        <div>
          <label>Elektrik Faturası Görseli:</label>
          <input
            type="file"
            onChange={(e) => setElectricBillFile(e.target.files[0])}
          />
        </div>
        <div>
          <label>Su Faturası Görseli:</label>
          <input
            type="file"
            onChange={(e) => setWaterBillFile(e.target.files[0])}
          />
        </div>
        <button
          type="button"
          onClick={handleSave}
          disabled={isSaving} // Kaydetme işlemi devam ediyorsa buton devre dışı
        >
          {isSaving ? "Faturalar Kaydediliyor..." : "Faturayı Kaydet"} {/* Buton metni */}
        </button>
      </form>
    </div>
  );
}

export default UploadPage;
